import { EthAddress } from '@xylabs/sdk-js'
import React from 'react'
import { useInView } from 'react-intersection-observer'

import ComponentSize from '../../../ComponentSize'
import { EntityLoader } from '../../../Contexts'
import EntityCard from './EntityCard'

interface Props {
  address: EthAddress
  page?: string
  size?: ComponentSize
}

const InView: React.FC<Props> = (props) => {
  const { address, size, page } = props

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  return (
    <div ref={ref}>
      {inView ? (
        <EntityLoader address={address}>
          <EntityCard page={page} size={size} />
        </EntityLoader>
      ) : (
        <EntityCard page={page} size={size} />
      )}
    </div>
  )
}

export default InView
